export default __webpack_public_path__ + "static/media/button_telegram.77455d74.png";